import { showErrorCommentModal, dismissWarning } from "../helpers";
import { log } from "util";
import ibsStore from "../components/Stores/IbsSurveyStore"
import store from "../components/Stores/SurveyStore"
import { deleteRow } from "./TableHelper";
import sharedStore from "../components/Stores/SharedStore";
import { mapToDropdownOption, mapIDToName } from "../ibsHelper";


export function openExplanationModal(rowId, errorId, value, errorInfo) {
    log(`openExplanationModal`, 1);
    showErrorCommentModal(errorInfo.qName, value, { "errorId": errorInfo.errorTypeID }, rowId, errorId);
}
export function dismissWarningTooltip(questionName, rowId, errorId) {
    dismissWarning(questionName, rowId, errorId, "dismiss");
}

export function openMandatesActionModal(rowNum, props, referenceToTable) {
    log(`openActionModal`, 1);
    let rowID = referenceToTable[rowNum].RowID;
    let actionField = referenceToTable[rowNum]?.action?.trim();
    if (actionField === "") return null
    if (rowID.toString().startsWith("A")) {
        deleteRow(rowNum, props, referenceToTable)

    } else {
        store.showMandateActionModal = true;
        store.editingMandate = true;
        store.showAssetOptions = false;


        let result = ibsStore.mandateData.find(obj => obj.rowID == rowID)
        if (result) {
            ibsStore.mandateModalInfo.RelativeRowNum = rowNum
            ibsStore.mandateModalInfo.FundName = result.fundName
            ibsStore.mandateModalInfo.ManagerName = result.managerName
            ibsStore.mandateModalInfo.IsLgpsPoolOptions = result.isLgpsPoolOption
            ibsStore.mandateModalInfo.VintageYear = result.vintageYear
            ibsStore.mandateModalInfo.CommitmentEndYear = result.commitmentEndYear;
            ibsStore.mandateModalInfo.IsClean = result.isClean;
            ibsStore.mandateModalInfo.IsSingleMandate = result.isSingleMandate
            ibsStore.mandateModalInfo.AssetClassName = result.assetClassName;
            ibsStore.mandateModalInfo.StyleName = result.styleName;
            ibsStore.mandateModalInfo.AssetClassID = result.assetClassID;
            ibsStore.mandateModalInfo.StyleID = result.styleID;
            ibsStore.mandateModalInfo.MandateID = result.mandateID;
            ibsStore.mandateModalInfo.AssetCatID = result.assetClassCategoryID;
            ibsStore.mandateModalInfo.LifeCycleStatus = result.lifeCycleStatus;
            ibsStore.mandateModalInfo.AccountCode = result.accountCode;
            ibsStore.mandateModalInfo.IsInCommitPeriod = result.isInCommitPeriod;
            ibsStore.mandateModalInfo.MandateRegionID = mapIDToName(sharedStore.mandateRegions, result.mandateRegionID, "mandateRegionID", "regionName");
            let subStyleName1 = mapIDToName(sharedStore.mandateSubstyles, result.subStyleID1, "subStyleID", "subStyleName")
            let subStyleName2 = mapIDToName(sharedStore.mandateSubstyles, result.subStyleID2, "subStyleID", "subStyleName")
            let subStyleName3 = mapIDToName(sharedStore.mandateSubstyles, result.subStyleID3, "subStyleID", "subStyleName")
            let stylesArr = [subStyleName1, subStyleName2, subStyleName3]
            let styleToAddToMandate = []
            for (var key in stylesArr)
                if (stylesArr[key] !== null)
                    styleToAddToMandate.push(stylesArr[key]);
            ibsStore.mandateModalInfo.MandateSubstyles = styleToAddToMandate;

        }
    }


}
